import Vue from 'vue'
import Router from 'vue-router'
import DashBoard from '@/view/dashBoard'
import Login from '@/view/login'
import ProductInfo from '@/view/productInfo'
import Personal from '@/view/personal'
import ssUtil from '@/utils/SStorage'
import PromptPage from '@/view/promptPage'
import MyFavorite from '@/view/myFavorite'
import $ from 'jquery'

Vue.use(Router)

let router = new Router({
    mode:'history',
    routes: [
        { path: '/', name: 'host', component: Login, meta: { title: '最好用的经济决策系统' }, },
        { path: '/login', name: 'login', component: Login, meta: { title: '最好用的经济决策系统' } },
        { path: '/dashBoard', name: 'dashBoard', component: DashBoard, meta: { title: '最好用的经济决策系统' } },
        { path: '/productInfo', name: 'productInfo' ,component: ProductInfo, meta: { title: '公司产品详情' } },
        { path: '/personal', name: 'personal' ,component: Personal, meta: { title: '个人中心' } },
        { path: '/promptPage', name: 'promptPage', component: PromptPage, meta: { title: '404页面' } },
        { path: '/myFavorite', name: 'myFavorite', component: MyFavorite, meta: { title: '个人收藏' } },
    ]
})

router.beforeEach((to, from, next) => {
    let titleStr = '琅琊天楹 - '
    if( to.meta.title ){
        titleStr += to.meta.title
    }
    document.title = titleStr;
    //控制小火箭的显示隐藏
    if( to.path =='/'|| to.path=='/dashBoard' || from.path=='/'){
        $('.backTop').show();
    }else{
        $('.backTop').hide();
    }

    if( (to.path=='/'||to.path=='/login')&&sessionStorage.getItem('authToken') &&ssUtil.getItem('isLogin')){
        next('/dashBoard');
    }else{
        next();
    }

})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js